
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 477.867 477.867"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M324.267 119.467c-9.426 0-17.067-7.641-17.067-17.067V0H102.4C74.123 0 51.2 22.923 51.2 51.2v375.467c0 28.277 22.923 51.2 51.2 51.2h273.067c28.277 0 51.2-22.923 51.2-51.2v-307.2h-102.4z","fill":"#b7d7b7","data-original":"#000000","xmlns":"http://www.w3.org/2000/svg"}}),_c('path',{attrs:{"fill":"#b7d7b7","data-original":"#000000","d":"M341.333 10.001v75.332h75.333z","xmlns":"http://www.w3.org/2000/svg"}})])
          )
        }
      }
    